"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhoneType = exports.PhoneNumberStatus = exports.DeliveryPreference = exports.ACTIVE_NUMBER_STATUSES = void 0;
var PhoneType = /*#__PURE__*/function (PhoneType) {
  PhoneType["Mobile"] = "mobile";
  PhoneType["Landline"] = "landline";
  PhoneType["Voip"] = "voip";
  PhoneType["Invalid"] = "invalid";
  return PhoneType;
}({});
exports.PhoneType = PhoneType;
var PhoneNumberStatus = /*#__PURE__*/function (PhoneNumberStatus) {
  PhoneNumberStatus["Active"] = "active";
  PhoneNumberStatus["ActiveNotVerified"] = "active-not-verified";
  PhoneNumberStatus["PendingVerification"] = "pending-verification";
  PhoneNumberStatus["Archived"] = "archived";
  return PhoneNumberStatus;
}({});
exports.PhoneNumberStatus = PhoneNumberStatus;
var ACTIVE_NUMBER_STATUSES = [PhoneNumberStatus.Active, PhoneNumberStatus.ActiveNotVerified];
exports.ACTIVE_NUMBER_STATUSES = ACTIVE_NUMBER_STATUSES;
var DeliveryPreference = /*#__PURE__*/function (DeliveryPreference) {
  DeliveryPreference["Stopped"] = "stopped";
  DeliveryPreference["Started"] = "started";
  return DeliveryPreference;
}({});
exports.DeliveryPreference = DeliveryPreference;